/*
* General custom scripts
**/
import 'lazysizes';
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

import './components/header';
import './components/footer';

//
